import { useTranslation } from "react-i18next";

import SeverityGridForm from "@/features/AssetTypes/SeverityGrids/SeverityGridForm";
import { useUpdate } from "@/hooks/queries";

const Edit = ({ model, assetTypeId }) => {
  const { t } = useTranslation();

  const mutation = useUpdate("severityGrids", model.id, {
    rootId: assetTypeId,
  });

  const initialValue = {
    name: model?.name,
    description: model?.description,
    severity_tree_translation: JSON.stringify(
      model?.severity_tree_translation,
      null,
      2
    ),
  };

  return (
    <SeverityGridForm
      mutation={mutation}
      saveButtonLabel={t("global:save")}
      initialValues={initialValue}
    />
  );
};

export default Edit;
